import * as React from 'react';
import * as cx from 'classnames';

import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';

import TextField, { TextFieldProps } from 'ha/ui/next/TextField';
import units from 'ha/theme/units';

export const styles = (theme: Theme) =>
  createStyles({
    textField: {
      borderRadius: '4px',
    },
    input: {
      color: theme.palette.darkBlue.main,
      textIndent: units.rem(1),
      fontSize: units.rem(1.25),
      lineHeight: 'normal',
    },
    root: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#F1F2F6',
      height: units.rem(3.5),
      borderRadius: units.rem(0.25),
      '&:before': {
        borderBottomColor: 'transparent',
      },
      '&:hover:before': {
        borderBottomColor: `${theme.palette.primary.light} !important`,
      },
    },
  });

export const SearchBarTextField: React.SFC<
  TextFieldProps & WithStyles<typeof styles>
> = ({
  classes,
  className,

  InputProps = {},
  ...rest
}) => (
  <TextField
    className={cx(classes.textField, className)}
    InputProps={{
      ...InputProps,
      classes: {
        ...InputProps.classes,
        root: cx(classes.root, InputProps.classes && InputProps.classes.root),
        input: cx(
          classes.input,
          InputProps.classes && InputProps.classes.input,
        ),
      },
    }}
    {...rest}
  />
);

export default withStyles(styles)(SearchBarTextField) as React.ComponentClass<
  TextFieldProps
>;
